import { render } from "./html-code-editor.vue?vue&type=template&id=23638378&scoped=true"
import script from "./html-code-editor.vue?vue&type=script&lang=js"
export * from "./html-code-editor.vue?vue&type=script&lang=js"

import "./html-code-editor.vue?vue&type=style&index=0&id=23638378&scoped=true&lang=css"
import "./html-code-editor.vue?vue&type=style&index=1&id=23638378&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23638378"]])

export default __exports__